import React, { useEffect } from 'react';
import './Select.css';

export interface SelectOption {
  option: any;
  key: string;
  value: string;
  displayValue: string;
}

interface SelectProps {
  onChange?: (value: string) => void;
  initialValue?: string;
  isDisabled?: boolean;
  placeholder?: string;
  options: SelectOption[];
  label?: string;
  id?: string;
}

const Select: React.FC<SelectProps> = ({
  initialValue = '',
  isDisabled = false,
  onChange,
  options,
  label = '',
  id,
}) => {

  useEffect(() => {
    const isInitialValueValid = options.some(option => option.value === initialValue);
    if (!isInitialValueValid) {
      if (options.length > 0) {
        onChange && onChange(options[0].value);
      } else {
        isDisabled = true;
        onChange && onChange('');
      }
    }
  }, [initialValue, onChange, options]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    onChange && onChange(newValue);
  };

  return (
    <div className='select-container'>
      { id && label !== '' ? <label htmlFor={id}>{label}</label> : <></> }
      <select
        id={id}
        className={`${isDisabled ? 'isDisabled' : ''}`}
        value={initialValue}
        onChange={handleChange}
        disabled={isDisabled}
      >
          {options.map(option => (
            <option key={option.key} value={option.value}>
              {option.displayValue}
            </option>
          ))}
      </select>
    </div>
  );
};

export default Select;
